import {
  AutoCompleteRequest,
  EquipmentIDAutocompleteResponse,
  SCACAutocompleteResponse,
  UsersAutocompleteResponse,
} from "@telegraphio/bapi-types";
import apiClient, { handleApiError } from "../openApiClient";

export interface AutocompleteApi {
  autocompleteEquipmentId(
    customerId: string,
    requestData: AutoCompleteRequest,
  ): Promise<EquipmentIDAutocompleteResponse>;
  autocompleteScac(customerId: string, requestData: AutoCompleteRequest): Promise<SCACAutocompleteResponse>;
  autocompleteUsers(customerId: string, requestData: AutoCompleteRequest): Promise<UsersAutocompleteResponse>;
}

export const autocompleteApi: AutocompleteApi = {
  async autocompleteEquipmentId(
    customerId: string,
    requestData: AutoCompleteRequest,
  ): Promise<EquipmentIDAutocompleteResponse> {
    const { data, error, response } = await apiClient.POST(`/autocomplete/{customer_id}/equipment_id`, {
      params: {
        path: {
          customer_id: customerId,
        },
      },
      body: {
        ...requestData,
      },
    });

    if (error) {
      handleApiError(error, response, "Failed to get autocomplete equipment id");
    }

    return data;
  },

  async autocompleteScac(customerId: string, requestData: AutoCompleteRequest): Promise<SCACAutocompleteResponse> {
    const { data, error, response } = await apiClient.POST(`/autocomplete/{customer_id}/scac`, {
      params: {
        path: {
          customer_id: customerId,
        },
      },
      body: {
        ...requestData,
      },
    });

    if (error) {
      handleApiError(error, response, "Failed to get autocomplete scac");
    }
    return data;
  },

  async autocompleteUsers(customerId: string, requestData: AutoCompleteRequest): Promise<UsersAutocompleteResponse> {
    const { data, error, response } = await apiClient.POST(`/autocomplete/{customer_id}/users`, {
      params: {
        path: {
          customer_id: customerId,
        },
      },
      body: {
        ...requestData,
      },
    });

    if (error) {
      handleApiError(error, response, "Failed to get autocomplete users");
    }
    return data;
  },
};
